import LoadingSquare from "shared/components/loading/LoadingSquare.js";
import React, { useState } from "react";
import Popup from "reactjs-popup";
import BoxCard from "shared/components/box/BoxCard.js";
import BoxMessage from "shared/components/box/BoxMessage.js";
import ItemRowMatch from "shared/components/items/ItemRowMatch.js";
import { getFormationMatches } from "shared/services/api-assistant.js";
import UtilConditionalRender from "shared/components/utils/UtilConditionalRender.js";
import Count from "shared/components/counts/Count.js";

/*interface PopupFormationInfoProps {
  trigger: React.ReactNode;
  onClose: () => void;
  data: Object;
  engine: String;
  formation1: String;
  formation2: String;
  maxOverallDifference: Number;
}*/

const PopupFormationInfo = ({ trigger, onClose, data, engine, formation1, formation2, maxOverallDifference }) => {
  const [page, setPage] = useState(null);
  const [matches, setMatches] = useState(null);
  const [canLoadMore, setCanLoadMore] = useState(false);

  if (!data) {
    return trigger;
  }

  const total = data.victories + data.draws + data.defeats;

  const winRate = total ? ((data.victories / total) * 100).toFixed(1) : "0.0";
  const drawRate = total ? ((data.draws / total) * 100).toFixed(1) : "0.0";
  const loseRate = total ? ((data.defeats / total) * 100).toFixed(1) : "0.0";

  const fetchMatches = () => {
    getFormationMatches({
      handleSuccess: (m) => {
        setMatches((prev) => (prev ? prev.concat(m.data.getMatches) : m.data.getMatches));
        setPage(page + 1);
        setCanLoadMore(m.data.getMatches.length === 20);
      },
      handleError: (e) => console.log(e),
      params: {
        skip: page * 20,
        limit: 20,
        engine,
        formation1,
        formation2,
        statuses: ["ENDED"],
        maxOverallDifference,
      },
    });
  };

  const onOpen = () => {
    setCanLoadMore(false);
    setMatches(null);
    setPage(0);
    fetchMatches();
  };

  return (
    <div className="PopupAddPlayers h-100 w-100" style={{ cursor: "pointer" }}>
      <Popup
        trigger={trigger}
        modal
        closeOnDocumentClick={false}
        onClose={onClose}
        className={"fade-in popup-xl"}
        onOpen={onOpen}
      >
        {(close) => (
          <div>
            <div className="d-flex flex-row mb-3">
              <div className="flex-grow-1">
                <h4 className="mb-0">
                  <i className="bi bi-shuffle me-2" />
                  {data.formation1}
                  {data.formation2 && " vs " + data.formation2}
                </h4>
              </div>
              <div className="flex-grow-0">
                <button className={"btn"} onClick={close}>
                  <i className="bi bi-x-lg"></i>
                </button>
              </div>
            </div>

            <div className="d-flex flex-column flex-md-row m-1 mb-2">
              <div className="d-flex flex-column flex-md-row flex-fill">
                <BoxCard
                  className="flex-grow-0 flex-md-basis-200"
                  content={
                    <div className="d-flex flex-fill flex-column">
                      <div className="my-3 d-flex flex-row flex-fill">
                        <div className="d-flex flex-grow-1 justify-content-center">
                          <Count label="Engine version" count={data.engine} />
                        </div>
                      </div>
                    </div>
                  }
                />

                <BoxCard
                  className="flex-grow-0 flex-md-basis-200"
                  content={
                    <div className="d-flex flex-fill flex-column">
                      <div className="my-3 d-flex flex-row flex-fill">
                        <div className="d-flex flex-grow-1 justify-content-center">
                          <Count label="Matches" count={total} />
                        </div>
                      </div>
                    </div>
                  }
                />

                <BoxCard
                  className="flex-grow-1"
                  content={
                    <div className="d-flex flex-fill flex-column">
                      <div className="d-flex flex-row flex-fill my-3">
                        <div className="d-flex flex-grow-1 justify-content-center">
                          <Count
                            label="Wins"
                            count={
                              <>
                                {data.victories} <small style={{ fontSize: "0.5em", color: "grey" }}>{winRate}%</small>
                              </>
                            }
                          />
                        </div>
                        <div className="d-flex flex-grow-1 justify-content-center">
                          <Count
                            label="Draws"
                            count={
                              <>
                                {data.draws} <small style={{ fontSize: "0.5em", color: "grey" }}>{drawRate}%</small>
                              </>
                            }
                          />
                        </div>
                        <div className="d-flex flex-grow-1 justify-content-center">
                          <Count
                            label="Losses"
                            count={
                              <>
                                {data.defeats} <small style={{ fontSize: "0.5em", color: "grey" }}>{loseRate}%</small>
                              </>
                            }
                          />
                        </div>
                      </div>
                    </div>
                  }
                />
              </div>
            </div>

            <div className="d-flex flex-column flex-fill">
              <BoxCard
                className="mb-2"
                title={"Matches"}
                content={
                  <UtilConditionalRender
                    value={matches}
                    renderOk={() => (
                      <div className="d-flex flex-fill flex-column">
                        {matches.map((m) => (
                          <ItemRowMatch match={m} />
                        ))}
                        {canLoadMore && (
                          <button
                            className="btn btn-sm btn-link align-self-start"
                            onClick={() => {
                              fetchMatches();
                            }}
                          >
                            Load more
                          </button>
                        )}
                      </div>
                    )}
                    renderEmpty={() => <BoxMessage className={"my-3"} content={"No match found"} />}
                    renderUndefined={() => (
                      <div className="w-100" style={{ height: "100px" }}>
                        <LoadingSquare height={"100px"} />
                      </div>
                    )}
                  />
                }
              />
            </div>
          </div>
        )}
      </Popup>
    </div>
  );
};

export default PopupFormationInfo;
